export const getStoplistOnly = store => store.stoplistonly
